import {
    STATISTICS_COUNTRY_SUCCESS
} from './constants';

const initialStatisticsCalendarState = [];

/**
 *
 * @param state
 * @param action
 */
const statisticsCountryCalendarReducer = (state = initialStatisticsCalendarState, action) => {
    switch (action.type) {
        case  STATISTICS_COUNTRY_SUCCESS: {
            return [...action.statistics ];
        }
        default:
            return state;
    }
};

export { statisticsCountryCalendarReducer  as countryStatistics};